import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { useTranslation } from "react-i18next";

const CUSTOM_SETTLEMENT_OPTIONS = [
  { key: "NONE", title: "None", value: "NONE" },
  { key: "USD_WEEKLY", title: "Set Wed to Tue USD transaction’s settlement date as upcoming Sat", value: "USD_WEEKLY" },
  { key: "USD_DAILY", title: "Set Sun to Tue USD transaction’s settlement date as upcoming Sat", value: "USD_DAILY" },
];

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementSettlementSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.settlementSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    settleCycle: {
      fieldType: "textInput",
      fieldName: "settleCycle",
      label: tLocal("label.settleCycle"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 2,
        asNumber: true,
        rules: ["onlyInteger"]
      }
    },
    customSettle: {
      fieldType: "selection",
      fieldName: "customSettle",
      label: tLocal("label.customSettle"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        options: CUSTOM_SETTLEMENT_OPTIONS,
        defaultValue: "NONE"
      }
    }
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.settleCycle,
              fieldsConfig.customSettle
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementSettlementSection